export default __webpack_public_path__ + "static/media/Countries.e52ab88a.png";